import React from 'react';
import styles from './entities_card_body.module.scss';

export const EntitiesCardBody: React.FC<{}> = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
